import React from 'react';

import { flagStyles } from '../settings';

const SvgKM = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2808px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgKM;
